import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'

const base = ['airwallex']

export const airwallexQueryConfig = {
  init: () => ({
    queryKey: buildQueryKey([...base, 'init']),
  }),
}
